<template>
  <div>
    <!-- Khidmat Pengurusan Menu -->
    <div
      class="khidmat-pengurusan-menu"
      :class="{ open: isKhidmatPengurusanMenuOpen }"
    >
      <ul>
        <!--
          <li class="menu-header">
          <span>KHIDMAT PENGURUSAN</span>
          </li> 
        -->
        <li>
          <RouterLink to="/khidmat-pengurusan"> Aset </RouterLink>
        </li>
        <li>
          <RouterLink to="/khidmat-pengurusan/latihan"> Latihan </RouterLink>
        </li>
        <li>
          <RouterLink to="/khidmat-pengurusan/perjawatan">
            Perjawatan
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/khidmat-pengurusan/kewangan"> Kewangan </RouterLink>
        </li>
        <li>
          <RouterLink to="/khidmat-pengurusan/kpi"> KPI </RouterLink>
        </li>
        <!-- <li>
          <RouterLink to="/khidmat-pengurusan/skt">
            SKU
          </RouterLink>
        </li> -->
      </ul>
    </div>
    <div
      v-if="isKhidmatPengurusanMenuOpen"
      class="overlay"
      @click="closeMenus"
    />
    <button
      v-if="!isKhidmatPengurusanMenuOpen"
      class="khidmat-pengurusan-toggle-button"
      @click="toggleKhidmatPengurusanMenu"
    >
      <span class="vertical-text">KHIDMAT PENGURUSAN</span>
    </button>
  </div>
</template>

<script setup>
import { ref } from "vue";

const isKhidmatPengurusanMenuOpen = ref(false);

const toggleKhidmatPengurusanMenu = () => {
  isKhidmatPengurusanMenuOpen.value = !isKhidmatPengurusanMenuOpen.value;
  if (isKhidmatPengurusanMenuOpen.value) {
    closeMainMenu();
  }
};

const closeMenus = () => {
  isKhidmatPengurusanMenuOpen.value = false;
  closeMainMenu();
};

const closeMainMenu = () => {
  // Emit event to close Main Menu
  const event = new CustomEvent("close-main-menu");

  window.dispatchEvent(event);
};

window.addEventListener("close-khidmat-pengurusan-menu", () => {
  isKhidmatPengurusanMenuOpen.value = false;
});
</script>

<style scoped>
/* Khidmat Pengurusan Menu */
.khidmat-pengurusan-menu {
  position: fixed;
  top: 30%;
  right: 0;
  width: 200px;
  height: auto;
  max-height: 70%;
  background-color: #312867;
  color: white;
  padding: 10px 15px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s;
  transform: translateX(100%);
  z-index: 1000;
  border-radius: 10px;
}

.khidmat-pengurusan-menu.open {
  transform: translateX(0);
}

.khidmat-pengurusan-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.khidmat-pengurusan-menu li {
  margin-bottom: 10px;
}

.khidmat-pengurusan-menu a,
.khidmat-pengurusan-menu router-link {
  color: white;
  text-decoration: none;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

/* Khidmat Pengurusan Toggle Button */
.khidmat-pengurusan-toggle-button {
  position: fixed;
  top: 40%;
  right: -10px;
  transform: translateY(-50%);
  background-color: #312867;
  border: none;
  padding: 2px;
  border-radius: 5px 0 0 5px;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 100;
  transition: right 0.3s;
  writing-mode: vertical-rl;
  text-orientation: mixed;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
}

.khidmat-pengurusan-toggle-button .vertical-text {
  writing-mode: vertical-rl;
  text-orientation: mixed;
}

.menu-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.2rem;
  font-weight: bold;
}
</style>
